import { ApolloProvider } from "@apollo/client";
import {
  DarkTheme,
  DefaultTheme,
  NavigationContainer,
} from "@react-navigation/native";
import { ThemeProvider } from "@towersystems/roam-common-native";
import * as SecureStore from "@towersystems/roam-common-native/lib/utilities/storage";
import {
  ThemeContext,
  ThemeContextType,
} from "@towersystems/roam-common-native/lib/utilities/theme";
import { lightColors } from "@towersystems/roam-common/lib/tokens";
import { registerRootComponent } from "expo";
import queryString from "query-string-es5";
import React from "react";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { SafeAreaProvider } from "react-native-safe-area-context";
import useCachedResources from "../hooks/useCachedResources";
import { client } from "./apollo";
import { App } from "./components/App/App";
import { register } from "./serviceWorkerRegistration";
import { USER_TOKEN_KEY } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { linking } from "./linking";

const MyTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: lightColors.primary,
  },
};

register({});

function Boot() {
  const isLoadingComplete = useCachedResources();

  React.useEffect(() => {
    // consume params
    initMaybeParams();
  }, []);

  const initMaybeParams = async () => {
    // will maybe need to change if app is not only for web
    const parsed = queryString.parse(location.search);

    if (parsed.auth) {
      SecureStore.storeItemAsync(USER_TOKEN_KEY, parsed.auth as string);
      window.history.replaceState(null, "", "/");
    }
  };

  if (!isLoadingComplete) {
    return null;
  }

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <ThemeProvider
        options={{
          themeScheme: {
            light: {
              surface: "#f5f5f5",
              cardBackgroundColor: "rgba(255,255,255,0.2)",
            },
            dark: {},
          },
        }}
      >
        <ThemeContext.Consumer
          children={(theme) => (
            <NavigationContainer
              linking={linking as any}
              theme={
                (theme as ThemeContextType).scheme === "dark"
                  ? DarkTheme
                  : MyTheme
              }
              onStateChange={() => {
                if ("serviceWorker" in navigator) {
                  navigator.serviceWorker.ready.then((registration) => {
                    if (registration.waiting) {
                      // send the skip message to kick off the service worker install.
                      registration.waiting.postMessage({
                        type: "SKIP_WAITING",
                      });
                      // add an listener to reload page when the new service worker is ready.
                      registration.waiting.addEventListener(
                        "statechange",
                        (event: Event) => {
                          const { state = "" } =
                            (event.target as unknown as {
                              state: string;
                            }) || {};
                          if (state === "activated") {
                            window.location.reload();
                          }
                        }
                      );
                    }
                  });
                }
              }}
            >
              <SafeAreaProvider>
                <ApolloProvider client={client}>
                  <App />
                </ApolloProvider>
              </SafeAreaProvider>
            </NavigationContainer>
          )}
        />
      </ThemeProvider>
    </GestureHandlerRootView>
  );
}

export default registerRootComponent(Boot);
